import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { setTimerWidgetClosingTime, clearTimerFromStorage } from "@swiggy-private/core-ui";

export const getClosingTimeInMs = (cartResponse: ReviewedCart | null): number => {
    return Number(cartResponse?.data?.restaurant_details?.closing_in_ms ?? 0);
};

export const isClosingTimeAvailable = (cartResponse: ReviewedCart | null): boolean => {
    const closingInMs = getClosingTimeInMs(cartResponse);
    return closingInMs !== 0;
};

export const setClosingTimeInStorage = (cartResponse: ReviewedCart | null): void => {
    if (isClosingTimeAvailable(cartResponse)) {
        const closingInMs = getClosingTimeInMs(cartResponse);
        const durationInSeconds = getClosingTimeFromApiInSeconds(cartResponse);
        const closeTime = Date.now() + closingInMs;
        setTimerWidgetClosingTime(closeTime, durationInSeconds);
    } else {
        clearTimerFromStorage();
    }
};

export const getClosingTimeFromApiInSeconds = (cartResponse: ReviewedCart | null): number => {
    const closingInMs = getClosingTimeInMs(cartResponse);
    return Math.round(closingInMs / 1000);
};
